define('flight-components/LiteEmailSignup',[
  'App',
  'flight/lib/component'
],
function (App, defineComponent) {

  var LiteEmailSignup = function LiteEmailSignup() {

    this.defaultAttrs({
      containerSelector: '.lite-email-signup',
      formWrapperSelector: '.lite-email-signup__wrapper',
      emailFormSelector: '#lite-email-signup-form',
      emailInputSelector: 'input[name="email"]',
      postalCodeInputSelector: 'input[name="postalCode"]',
      errorMsgSelector: '.input-error-msg',
      formSuccessMsg: '.form-success-msg'
    });

    this.handleFormSubmit = function(ev, data) {
      var self = this;
      ev.preventDefault();

      var $form = $(data.el);
      var formData = this.parseNamedFields($form);

      if ( this.validate(formData) ) {
        
        var xhr = $.ajax({
          url: App.context + '/litesignUp/submit',
          data: formData
        });

        xhr.success(function(response){
          if (response.status == 'success') {
            self.showSuccessMsg();
            self.trigger(document, 'ui-track-event', {name: 'liteEmailSignupSuccess'});
          } else {
            self.handleResponseErrors(response.content);
          }
        });

      } else {
        // TODO - refactor error handling
      }

    };

    this.parseNamedFields = function($el) {
      var data = {};
      $el.find('input[name]').each(function() {
        data[$(this).attr('name')] = $(this).val();
      });
      return data;
    }

    this.validate = function(data) {
      var isValid = true;

      if ( !this.isValidEmail(data.email) ) {
        isValid = false;
        this.showError('email'); 
      }

      if ( !this.isValidPostalCode(data.postalCode) ) {
        isValid = false;
        this.showError('postalCode');
      }

      return isValid;

    };

    this.isValidEmail = function(email) { 
      var validEmail = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
      return validEmail.test(email);
    };

    this.isValidPostalCode = function(pcode) {
      var usRegPostalCode = new RegExp("^\\d{5}(-\\d{4})?$");
      var canRegPostalCode = new RegExp("^([A-Za-z][0-9][A-Za-z])\\s*([0-9][A-Za-z][0-9])?$");
      if (usRegPostalCode.test(pcode) || canRegPostalCode.test(pcode)) {
        return true;
      } else {
        return false;
      }
    };

    this.hideError = function(field) {
      if (!field) return;
      var $field = this.$node.find('input[name="'+ field +'"]');
      $field.removeClass('error');
      $field.siblings(this.attr.errorMsgSelector).hide();
    };

    this.showError = function(field, msg) {
      var $field = this.$node.find('input[name="'+ field +'"]');
      $field.addClass('error');
      if (msg) {
        $field.siblings(this.attr.errorMsgSelector).text(msg).show();
      } else {
        $field.siblings(this.attr.errorMsgSelector).show();
      }
    };

    this.showSuccessMsg = function(){
      this.select('formWrapperSelector').hide();
      this.select('containerSelector').find(this.attr.formSuccessMsg).show();
    };

    this.handleResponseErrors = function(errors) {
      alert('There was an error.');
    };

    this.after('initialize', function () {

      var self = this;

      this.on('submit', {
        emailFormSelector: this.handleFormSubmit
      });

      this.$node.on('focus', 'input', function(ev){
        self.hideError( $(this).attr('name') );
      })

    });
  };

  return defineComponent(LiteEmailSignup);

});

